import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { _var } from '@/enums/Common';
import store from '@/store';
import {
	isTutorialVirtualHttpRequest,
	mockTutorialVirtualAxiosResponse,
} from '@/features/tutorial/virtualStudent';

export const $http: AxiosInstance = axios.create({
	baseURL: process.env.VUE_APP_BASE_URL,
});

$http.defaults.headers.common['x-access-token'] = localStorage.getItem(
	_var.TOKEN
);
$http.defaults.headers.common['x-subdomain'] = localStorage.getItem(
	_var.SUBDOMAIN
);
$http.interceptors.request.use((req: any) => {
	req['x-access-token'] = localStorage.getItem(_var.TOKEN);
	req['x-subdomain'] = localStorage.getItem(_var.SUBDOMAIN);
	if (isTutorialVirtualHttpRequest(req)) {
		req.adapter = () =>
			Promise.resolve(mockTutorialVirtualAxiosResponse(req));
	}
	return req;
});
$http.interceptors.response.use(
	(config: AxiosResponse) => {
		return config;
	},
	(error) => {
		const status = error?.response?.status;
		const isOnSignIn = window.location.pathname.includes('/signin');

		if (status === 401) {
			localStorage.clear();
			// Avoid full-page reload loop when already on sign-in
			if (!isOnSignIn) {
				window.location.href = '/signin';
			}
			return Promise.reject(error);
		}
		if (status === 500) {
			return store.dispatch('setAlertMessage', {
				message: 'Đã có lỗi xảy ra. Vui lòng thử lại.',
				type: 'error',
			});
		}
		if (status === 403) {
			if (
				error.response.data.error_code === 'FEATURE_NO_ACCESS' ||
				error.response.data.error_code === 'FEATURE_VIEW_ONLY'
			) {
				return store.dispatch('setAlertMessage', {
					message: error.response.data.message,
					type: 'error',
				});
			}
		}
		if (status === 412) {
			const message =
				'Chúng tôi rất tiếc phải khóa tài khoản của quý cơ sở của trên Luca Education, do gói đăng ký của quý cơ sở hiện đã hết hạn hoặc chưa hoàn thành thanh toán. Vui lòng gia hạn gói hoặc hoàn thành thanh toán để tiếp tục sử dụng.';
			return store.dispatch('setAlertMessageDontHide', {
				message: message,
				type: 'error',
			});
		}
		return Promise.reject(error);
	}
);
